import http from './http';
// import { wOrgIdMiddleware } from '../utils/commonUtils';

const AuditLogService = {
    
    getAuditLogList:(async(query)=>{
        const queryString = new URLSearchParams(query).toString();
        const response = await http.GET(`audit-log?${queryString}`);
        console.log('Audit log response:', response.data);
        return response.data;  
    }),

    getAuditLogModels: (async (query = {}) => {
        const queryString = new URLSearchParams(query).toString();
        const response = await http.GET(`audit-log/models?${queryString}`);
        return response.data;
    }),

    getAuditLogUsers: (async (query = {}) => {
        const queryString = new URLSearchParams(query).toString();
        const response = await http.GET(`audit-log/users?${queryString}`);
        return response.data;
    }),
};

export default AuditLogService;